export const theme = {
  colors: {
    // Primary colors - Nature inspired
    primary: {
      main: '#2E7D32', // Rich forest green
      light: '#4CAF50', // Fresh leaf green
      dark: '#1B5E20', // Deep forest green
      contrast: '#FFFFFF',
    },
    // Secondary colors - Earth tones
    secondary: {
      main: '#795548', // Rich soil brown
      light: '#8D6E63', // Light soil brown
      dark: '#5D4037', // Dark soil brown
      contrast: '#FFFFFF',
    },
    // Accent colors - Harvest inspired
    accent: {
      main: '#FF9800', // Warm harvest orange
      light: '#FFB74D', // Light harvest orange
      dark: '#F57C00', // Deep harvest orange
      contrast: '#000000',
    },
    // Success colors - Growth inspired
    success: {
      main: '#388E3C', // Growth green
      light: '#66BB6A', // Light growth green
      dark: '#2E7D32', // Deep growth green
      contrast: '#FFFFFF',
    },
    // Warning colors - Harvest inspired
    warning: {
      main: '#FFA000', // Harvest warning
      light: '#FFB74D', // Light warning
      dark: '#F57C00', // Deep warning
      contrast: '#000000',
    },
    // Error colors - Alert inspired
    error: {
      main: '#D32F2F', // Alert red
      light: '#EF5350', // Light alert
      dark: '#B71C1C', // Deep alert
      contrast: '#FFFFFF',
    },
    // Neutral colors - Soil inspired
    grey: {
      50: '#FAFAFA', // Light soil
      100: '#F5F5F5', // Very light soil
      200: '#EEEEEE', // Lighter soil
      300: '#E0E0E0', // Light grey soil
      400: '#BDBDBD', // Medium soil
      500: '#9E9E9E', // Grey soil
      600: '#757575', // Dark soil
      700: '#616161', // Darker soil
      800: '#424242', // Very dark soil
      900: '#212121', // Almost black soil
    },
    // Text colors
    text: {
      primary: '#1B5E20', // Deep forest green
      secondary: '#2E7D32', // Forest green
      disabled: '#90A4AE', // Light blue-grey
      hint: '#78909C', // Hint blue-grey
    },
    // Background colors
    background: {
      default: '#F1F8E9', // Very light green
      paper: '#FFFFFF', // White paper
      dark: '#1B5E20', // Deep forest green
    },
    // Action colors
    action: {
      active: 'rgba(46, 125, 50, 0.54)', // Forest green with opacity
      hover: 'rgba(46, 125, 50, 0.04)', // Very light forest green
      selected: 'rgba(46, 125, 50, 0.08)', // Light forest green
      disabled: 'rgba(46, 125, 50, 0.26)', // Medium forest green
      disabledBackground: 'rgba(46, 125, 50, 0.12)', // Light forest green
    },
  },
  // Typography
  typography: {
    fontFamily: '"Poppins", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
      lineHeight: 1.2,
      color: '#1B5E20',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.3,
      color: '#1B5E20',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
      lineHeight: 1.4,
      color: '#1B5E20',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: 1.4,
      color: '#1B5E20',
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: 1.4,
      color: '#1B5E20',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 1.4,
      color: '#1B5E20',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
      color: '#2E7D32',
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.43,
      color: '#2E7D32',
    },
    button: {
      fontSize: '0.875rem',
      fontWeight: 500,
      textTransform: 'none',
    },
  },
  // Spacing
  spacing: {
    xs: '2px',
    sm: '4px',
    md: '8px',
    lg: '16px',
    xl: '24px',
    xxl: '32px',
  },
  // Border radius
  borderRadius: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    round: '50%',
  },
  // Shadows
  shadows: {
    sm: '0 2px 4px rgba(46, 125, 50, 0.05)', // Forest green shadow
    md: '0 4px 8px rgba(46, 125, 50, 0.08)', // Medium forest green shadow
    lg: '0 8px 16px rgba(46, 125, 50, 0.12)', // Large forest green shadow
    xl: '0 12px 24px rgba(46, 125, 50, 0.15)', // Extra large forest green shadow
  },
  // Transitions
  transitions: {
    default: 'all 0.3s ease',
    fast: 'all 0.2s ease',
    slow: 'all 0.4s ease',
  },
  // Z-index
  zIndex: {
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },
  // Breakpoints
  breakpoints: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
}; 